import { render, staticRenderFns } from "./GroupCount.vue?vue&type=template&id=b04e1930&"
import script from "./GroupCount.vue?vue&type=script&lang=js&"
export * from "./GroupCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports